import { FC } from 'react';

const Transactions: FC = () => {
  return <>Transactions</>;
};

export default Transactions;
